import dynamic from 'next/dynamic'
import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'
import { allowedHtmlTags } from '@widgets/TextBody'

interface Props {
  text: string
}

const HTMLView = dynamic(() => import('@components/HTMLView'))

const SummaryContentWrapper = styled.div`
  ${({
    theme: {
      color: {
        primary: { blickRed: blickRedColor },
      },
      spacing: { spacing12, spacing16 },
      typography: {
        bodycopy: {
          small2: { bundledCSS: small2BodyCopy },
        },
      },
    },
  }) => css`
    ${small2BodyCopy}
    margin-bottom: ${spacing16};

    ul {
      list-style-type: none;
      list-style-position: outside;
      margin-top: 0;

      li {
        margin: 0;
        padding-bottom: ${spacing12};
        position: relative;

        &:last-child {
          padding-bottom: 0;
        }
      }

      li::marker {
        display: none;
        content: '';
      }

      li::before {
        content: '•';
        position: absolute;
        left: -19px;
        top: 5px;
        width: 10px;
        height: 10px;
        font-size: 28px;
        line-height: 10px;
        color: ${blickRedColor};
      }
    }
  `}
`

const SummaryContent: FunctionComponent<Props> = ({ text }) => {
  return (
    <SummaryContentWrapper>
      <HTMLView content={text} allowedHtmlTags={allowedHtmlTags} />
    </SummaryContentWrapper>
  )
}

export default SummaryContent
